import type { CSSProperties } from 'react'
import Modal from './Modal'
import type { GameState } from '../stores/gameStore'

type Difficulty = GameState['aiDifficulty']

interface DifficultyOption {
  value: string
  label: string
  accent: string
}

interface DifficultyPickerProps {
  options: DifficultyOption[]
  current: Difficulty
  onPick: (value: Difficulty) => void
  onClose: () => void
}

const DIFFICULTY_DESC: Record<Difficulty, string> = {
  easy: 'Go easy on me, I’m still learning!',
  medium: 'I’ve picked up a few tricks.',
  hard: 'Now you’re in for a real fight.',
  advanced: 'Good luck trying to beat me.',
}

// Shown when the player clicks Play — an explicit, unmissable difficulty choice
// (a 2×2 grid of cards) instead of a dropdown that's easy to overlook.
export default function DifficultyPicker({ options, current, onPick, onClose }: DifficultyPickerProps) {
  return (
    <Modal title="Choose Difficulty" onClose={onClose}>
      <p className="difficulty-lead">How strong should your opponent play?</p>
      <div className="difficulty-grid">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className="difficulty-card"
            style={{ '--accent': opt.accent } as CSSProperties}
            aria-current={opt.value === current}
            onClick={() => onPick(opt.value as Difficulty)}
          >
            <span className="difficulty-card-name">{opt.label}</span>
            <span className="difficulty-card-desc">{DIFFICULTY_DESC[opt.value as Difficulty]}</span>
          </button>
        ))}
      </div>
    </Modal>
  )
}
